import React from "react";
import Image from "components/image";
import clsx from "clsx/lite";
import { futureDateFormat } from "helpers/date";
import RichText from "components/rich-text";
import ReadMore from "components/read-more";

const Logistics = ({ data }) => {
	if (!data) return null;
	const { shipment, delivery, hideServicesInfo = false } = data;
	if (hideServicesInfo || !shipment || !delivery) return null;

	const shippingDates = { from: futureDateFormat(shipment.from), to: futureDateFormat(shipment.to) };
	const deliveryDates = { from: futureDateFormat(delivery.from + shipment.to), to: futureDateFormat(delivery.to + shipment.to) };

	const { from: shipmentFrom, to: shipmentTo } = shippingDates;
	const { from: deliveryFrom, to: deliveryTo } = deliveryDates;

	return (
		<p className="font-bold w-fit mb-4 pr-2 bg-lightGray">
            Orders placed Today, will Ship by <span className="underline">{shipmentFrom} - {shipmentTo}</span>,
            and will be delivered by <span className="underline">{deliveryFrom} - {deliveryTo}</span>
		</p>
	);
};

const DefaultTabContent = ({ activeTabData, crawlText, logistics }) => {
	const isShippingTab = activeTabData?.title.toLowerCase().includes("shipping");

	return (
		<>
			{isShippingTab && <Logistics data={logistics} />}
			<div className="flex flex-col md:flex-row gap-5 md:gap-10">
				<div className={clsx("w-full", activeTabData?.image && "md:w-2/3")}>
					<RichText data={activeTabData} />
				</div>
				{activeTabData?.image && (
					<div className="w-full md:w-1/3">
						<Image image={activeTabData?.image} />
					</div>
				)}
			</div>
			{crawlText && isShippingTab && (
				<div className="-mt-10">
					<ReadMore>
						<p className="py-8" />
						<p>{crawlText}</p>
					</ReadMore>
				</div>
			)}
		</>
	);
};

export default DefaultTabContent;
